import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SearchIcon from "@mui/icons-material/Search";
import "./styles/OrderHistory.css";

/* ── MOCK DATA ── */
const MOCK_ORDERS = [
  {
    id: "ORD-2024-001",
    date: "12 Jan 2025",
    status: "Delivered",
    total: 25842,
    items: 3,
    products: ["Vacuum Pump", "Manifold Gauge", "Tube Bender"],
  },
  {
    id: "ORD-2024-002",
    date: "28 Feb 2025",
    status: "Shipped",
    total: 50091,
    items: 2,
    products: ["Scroll Compressor", "Manifold Gauge"],
  },
  {
    id: "ORD-2024-003",
    date: "05 Apr 2025",
    status: "Processing",
    total: 19199,
    items: 4,
    products: ["R-410A Refrigerant Cylinder", "R-134A Gas Can", "Stabilizer 1 KVA", "Tube Cutter"],
  },
  {
    id: "ORD-2024-004",
    date: "18 Apr 2025",
    status: "Cancelled",
    total: 11200,
    items: 1,
    products: ["Rotary Compressor"],
  },
];

const STATUS_MAP = {
  Delivered:  { cls: "oh-status--delivered",  label: "Delivered"  },
  Shipped:    { cls: "oh-status--shipped",    label: "Shipped"    },
  Processing: { cls: "oh-status--processing", label: "Processing" },
  Cancelled:  { cls: "oh-status--cancelled",  label: "Cancelled"  },
};

const OrderHistory = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");

  const filters = ["All", "Delivered", "Shipped", "Processing", "Cancelled"];

  const filtered = MOCK_ORDERS.filter((o) => {
    const matchFilter = filter === "All" || o.status === filter;
    const matchSearch =
      !search ||
      o.id.toLowerCase().includes(search.toLowerCase()) ||
      o.products.some((p) => p.toLowerCase().includes(search.toLowerCase()));
    return matchFilter && matchSearch;
  });

  return (
    <div className="oh-root">
      <div className="dash-page-header">
        <h1 className="dash-page-title">Order History</h1>
        <p className="dash-page-sub">Track and manage your past orders</p>
      </div>

      {/* ── CONTROLS ── */}
      <div className="oh-controls">
        <div className="oh-search-wrap">
          <SearchIcon className="oh-search-icon" />
          <input
            type="text"
            placeholder="Search by order ID or product..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="oh-search-input"
          />
        </div>
        <div className="oh-filters">
          {filters.map((f) => (
            <button
              key={f}
              className={`oh-filter-btn${filter === f ? " oh-filter-btn--active" : ""}`}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      {/* ── ORDER LIST ── */}
      {filtered.length === 0 ? (
        <div className="oh-empty">
          <ReceiptLongIcon className="oh-empty-icon" />
          <div className="oh-empty-text">No orders found</div>
          <div className="oh-empty-sub">Try adjusting your search or filter</div>
        </div>
      ) : (
        <div className="oh-list">
          {filtered.map((order) => {
            const s = STATUS_MAP[order.status];
            return (
              <div
                key={order.id}
                className="oh-card"
                onClick={() => navigate(`/dashboard/orders/${order.id}`)}
              >
                <div className="oh-card-top">
                  <div>
                    <div className="oh-order-id">{order.id}</div>
                    <div className="oh-order-date">{order.date}</div>
                  </div>
                  <span className={`oh-status ${s.cls}`}>{s.label}</span>
                </div>

                <div className="oh-card-mid">
                  <div className="oh-products">
                    {order.products.slice(0, 2).map((p, i) => (
                      <span key={i} className="oh-product-tag">{p}</span>
                    ))}
                    {order.products.length > 2 && (
                      <span className="oh-product-more">+{order.products.length - 2} more</span>
                    )}
                  </div>
                </div>

                <div className="oh-card-bottom">
                  <div className="oh-meta">
                    <span className="oh-items">{order.items} item{order.items > 1 ? "s" : ""}</span>
                    <span className="oh-total">₹ {order.total.toLocaleString("en-IN")}</span>
                  </div>
                  <button className="oh-detail-btn">
                    View Details <ChevronRightIcon style={{ fontSize: 18 }} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OrderHistory;